import { render, staticRenderFns } from "./PieGraphic.vue?vue&type=template&id=89f17620&"
import script from "./PieGraphic.vue?vue&type=script&lang=js&"
export * from "./PieGraphic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports